<template>
  <v-container id="regular-tables" fluid tag="section">
    <base-material-card
      icon="mdi-clipboard-outline"
      :title="`${currentGroup.name}, ${currentExam.subjectName}`"
      class="px-5 py-3"
    >
      <v-row>
        <v-spacer class="row"></v-spacer>
      </v-row>
      <v-row>
        <v-col cols="12" md="2" lg="2">
          <v-btn color="red" class="ml-3" @click="deleteSelected()">o'chirish</v-btn>
        </v-col>
        <v-col cols="12" md="2" lg="2" class="mx-auto">
          <v-text-field
            v-model="search.name"
            outlined
            dense
            label="F.I dan qidirish"
            append-icon="mdi-magnify"
          />
        </v-col>
        <v-col cols="12" lg="2" md="2">
          <v-btn color="primary" @click="exportCsv">Export</v-btn>
        </v-col>
      </v-row>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="filteredItems"
        :search="search.name"
        item-key="id"
        show-select
      >
        <template v-slot:item.startedTime="{ item }">
          {{
          item.startedTime | moment("LLL")
          }}
        </template>
        <template v-slot:item.finishedTime="{ item }">
          {{
          item.finishedTime | moment("LLL")
          }}
        </template>
        <template v-slot:item.fullname="{ item }">
          {{
          fullName(item)
          }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon color="cyan" @click="show(item)">mdi-eye</v-icon>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import service from "../../service/Result.service";
import examService from "../../service/Exam.service";
import csv from "../../service/csv.servise";
import groupService from "../../service/Group.service";

export default {
  name: "ResultTable",
  data() {
    return {
      valid: true,
      rule: [v => !!v || "To'ldirilmagan"],
      ruleFile: [
        value =>
          !value ||
          value.size < 10000000 ||
          "Csv size should be less than 2 MB!",
      ],
      search: {
        name: "",
        groupId: "",
        universityId: "",
        subjectId: "",
      },
      selected: [],
      dialog: false,
      headers: [
        {
          text: "F.I.SH",
          align: "start",
          value: "userName",
          width: "25%",
          divider: true,
        },
        {
          text: "S.Time",
          value: "startedTime",
          width: "20%",
          align: "center",
          divider: true,
        },
        {
          text: "F.Time",
          value: "finishedTime",
          width: "20%",
          align: "center",
          divider: true,
        },
        {
          text: "score",
          value: "score",
          width: "20%",
          align: "center",
          divider: true,
        },
        {
          text: "action",
          value: "action",
          width: "15%",
          align: "center",
          divider: true,
        },
      ],
      items: [],
      file: null,
      currentGroup: {
        id: "",
        name: "",
      },
      currentExam: {
        id: "",
        name: "",
      },
      indexItem: -1,
      jwt: "",
    };
  },
  computed: {
    csvData() {
      return this.filteredItems.map(item => ({
        fullName: item.userName, //item.address.city,
        fan: item.examName,
        ball: item.score, //item.company.name
      }));
    },
    filteredItems() {
      return this.items;
    },
  },
  created() {
    this.initial();
  },
  methods: {
    exportCsv() {
      csv.csvExport(`${this.currentGroup.name}_${this.currentExam.name}`, this.csvData);
    },
    initial() {
      this.jwt = this.$store.getters.jwt;
      service
        .getByExam(this.$route.params.id, this.jwt)
        .then(res => {
          this.items = res.data;
        })
        .catch(err => {
          alert(err);
        });
      examService
        .getOne(this.$route.params.id, this.jwt)
        .then(res => {
          this.currentExam = res.data;
          groupService
            .getOne(this.currentExam.groupId, this.jwt)
            .then(res => {
              this.currentGroup = res.data;
            })
            .catch(err => {
              alert(err);
            });
        })
        .catch(err => {
          alert(err);
        });
    },
    show(item) {
      this.$router.push(`/result-history/${item.id}`);
    },
    fullName(item) {
      return `${item.lastName} ${item.name} ${item.surName}`;
    },
    deleteSelected() {
      confirm("Are you sure") &&
        this.selected.forEach(item => {
          const index = this.items.indexOf(item);
          service
            .delete(item.id, this.jwt)
            .then(() => {
              this.items.splice(index, 1);
            })
            .catch(err => {
              alert(err);
            });
        });
      this.selected = [];
    },
  },
};
</script>

<style scoped></style>
